import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './i18n/I18nProvider';
import { EventProvider } from './i18n/EventProvider';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Gathering from './components/Gathering';
import Flyer from './components/Flyer';
import VisitorCard from './components/VisitorCard';
import RSVP from './components/RSVP';
import DiscoverGrowServe from './components/DiscoverGrowServe';
import Sermons from './components/Sermons';
import BibleStudies from './components/BibleStudies';
import Prayer from './components/Prayer';
import Vision from './components/Vision';
import CoreValues from './components/CoreValues';
import Pastors from './components/Pastors';
import NextSteps from './components/NextSteps';
import { Give, Footer } from './components/GiveFooter';
import AdminDashboard from './pages/AdminDashboard';

const Landing = () => (
  <div className="App">
    <Navbar />
    <Hero />
    <Gathering />
    <Flyer />
    <VisitorCard />
    <RSVP />
    <DiscoverGrowServe />
    <Sermons />
    <BibleStudies />
    <Prayer />
    <Vision />
    <CoreValues />
    <Pastors />
    <NextSteps />
    <Give />
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <EventProvider>
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
    </EventProvider>
  );
}

export default App;
